<template>
    <div>
        <div class="title-label" v-if="!noTitle">
            {{ $t('common.updating_weighing') }}
        </div>

        <v-row class="mt-2">
            <v-col cols="12" class="mt-3">
                <kimsa-slider
                    :label="$t('entrance.height')"
                    units="m"
                    color="secondary"
                    :value="1"
                    :labels-interval=".099"
                    :step=".01"
                    :min="1"
                    :max="2"
                    @change="height = $event"
                    ref="height"
                />
            </v-col>

            <v-col cols="12" class="mt-3">
                <kimsa-slider
                    :label="$t('entrance.weight')"
                    units="kg"
                    color="secondary"
                    :labels-interval="10"
                    :value="60"
                    :step="1"
                    :min="40"
                    :max="140"
                    @change="weight = $event"
                    ref="weight"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import KimsaSlider from "../common/inputs/KimsaSlider";

export default {
    props: {
        noTitle: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        KimsaSlider,
    },
    data() {
        return {
            height: '',
            weight: '',
        }
    },
    computed: {
        form(vm = this) {
            return {
                height: vm.height,
                weight: vm.weight,
            }
        }
    },
    mounted() {
        const vm = this

        if (vm.account) {
            if (vm.account.height) vm.$refs.height.model = vm.account.height
            if (vm.account.weight) vm.$refs.weight.model = vm.account.weight
        }
    },
    watch: {
        weight() {
            this.$emit('change', this.form)
        },
        height() {
            this.$emit('change', this.form)
        },
    },
}
</script>

<style scoped>

.title-label {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
}

</style>